'use client';

import { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { FixAchPaymentButton } from '@/components/admin/FixAchPaymentButton';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Info } from 'lucide-react';

export default function FixPaymentPage() {
  const [paymentIntentId, setPaymentIntentId] = useState('');

  return (
    <div className="container mx-auto p-6 max-w-2xl">
      <h1 className="text-3xl font-bold mb-6">Fix Stuck ACH Payment</h1>
      
      <Alert className="mb-6">
        <Info className="h-4 w-4" />
        <AlertTitle>Manual Fix Tool</AlertTitle>
        <AlertDescription>
          Use this tool to manually process ACH payments that were marked as succeeded in Stripe 
          but weren't processed by the webhook. This will update the payment status and automatically 
          create the Purchase Order.
        </AlertDescription>
      </Alert>

      <Card>
        <CardHeader>
          <CardTitle>Payment Details</CardTitle>
          <CardDescription>
            Enter the Stripe Payment Intent ID (starts with pi_)
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="paymentIntentId">Payment Intent ID</Label>
            <Input
              id="paymentIntentId"
              placeholder="pi_3SWVheGmPvOgaKaQ0GeL2dlF"
              value={paymentIntentId}
              onChange={(e) => setPaymentIntentId(e.target.value)}
            />
          </div>

          {paymentIntentId && (
            <FixAchPaymentButton
              paymentIntentId={paymentIntentId}
              onSuccess={() => {
                setPaymentIntentId('');
              }}
            />
          )}

          <div className="mt-6 p-4 bg-muted rounded-lg">
            <h3 className="font-semibold mb-2">How to use:</h3>
            <ol className="list-decimal list-inside space-y-1 text-sm text-muted-foreground">
              <li>Get the Payment Intent ID from Stripe Dashboard (Events → payment_intent.succeeded)</li>
              <li>Paste it in the field above</li>
              <li>Click "Fix ACH Payment"</li>
              <li>The system will:
                <ul className="list-disc list-inside ml-6 mt-1">
                  <li>Update payment transaction to "held_in_escrow"</li>
                  <li>Set settlement timestamps</li>
                  <li>Create the Purchase Order automatically</li>
                  <li>Update job payment status</li>
                  <li>Send notifications to both parties</li>
                </ul>
              </li>
            </ol>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
